import React from 'react';

import { NavigationCell } from '../NavigationCell';
import { useIsChain } from '@utils/useIsChain';
import plurify from '@utils/plurify';

import styles from '../../InventoryViewer.module.scss';

const useQuantity = (row, onClick) => {
	const isChain = useIsChain();
	if (isChain) {
		return row.inStockTotal > 0 ? (
			<>
				{row.inStockTotal.toLocaleString()} in{' '}
				<span
					className={styles.link}
					onClick={(e) => {
						if (!onClick) return;
						e.stopPropagation();
						onClick(row);
					}}
				>
					{row.inStockLocations} {plurify('location', row.inStockLocations)}
				</span>
			</>
		) : (
			<>
				{row.inStockTotal.toLocaleString()} in {row.inStockLocations} {plurify('location', row.inStockLocations)}
			</>
		);
	}
	return row.quantity?.toLocaleString();
};

const Quantity = ({ row, onClick }) => {
	const quantity = useQuantity(row, onClick);

	return <NavigationCell barcode={row.barcode}>{quantity}</NavigationCell>;
};

export { Quantity, useQuantity };
